import React, { useEffect, useState } from 'react';
import { Drawer, makeStyles, Button } from '@material-ui/core';
import {
  UIBUILDER_PAGES,
  UIBUILDER_PAGE_BUILDER,
  UIBUILDER_PAGE_CREATE,
  UIBUILDER_PAGE_EDIT,
  UIBUILDER_PAGE_VIEW,
  UIBUILDER_MENU,
} from '../../constants/UiBuilderConst';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import UiBuilderPagesCreate from './pages/pages-create/Pages-Create';
import UiBuilderPagesList from './pages/pages-list/Pages-List';
import UiBuilderPageBuilder from './pages/page-builder/Page-Builder';
import {
  allHotelsSelector,
  fetchAllUIBuilderFlows,
  fetchAllUIBuilderHotelModuleOptions,
  fetchAllUIBuilderMenu,
  fetchAllUIBuilderPages,
  selectedHotelSelector,
  setIsUiBuilderEditModeStatus,
} from '../property/propertySlice';
import UiBuilderMenuList from './menu/menu-list/Menu-List';
import './Ui-Builder-Mobile.scss';
import { validateUserSession } from '../../utils/authUtils';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const UiBuilderMobile = (props) => {
  const { showLoader = () => {} } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(UIBUILDER_PAGES);
  const [state, setState] = useState({
    type: UIBUILDER_PAGE_CREATE,
    status: false,
  });
  const selectedHotel = useSelector(selectedHotelSelector);
  const originalHotels = useSelector(allHotelsSelector);
  const [groupId, setGroupId] = useState(null);
  const dispatch = useDispatch();
  const [viewState, setViewState] = useState({
    type: UIBUILDER_PAGE_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const history = useHistory();

  useEffect(() => {
    if (activeTab === UIBUILDER_PAGES || activeTab === UIBUILDER_MENU) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

useEffect(() => {
  if (selectedHotel) {
    const selectedHotelDetails = originalHotels.find((hotel) => hotel.id === selectedHotel);
    if (selectedHotelDetails?.isUIBuilderEnabled) {
      dispatch(fetchAllUIBuilderPages(selectedHotel));
      dispatch(fetchAllUIBuilderMenu(selectedHotel));
      dispatch(fetchAllUIBuilderFlows());
      dispatch(fetchAllUIBuilderHotelModuleOptions());
      setGroupId(selectedHotelDetails.groupId);
    } else if (originalHotels.length > 0) {
      history.push('/properties');
    }
  }
}, [dispatch, selectedHotel, originalHotels]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(UIBUILDER_PAGES);
    }
  }, [selectedHotel, viewState.status]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case UIBUILDER_PAGE_CREATE:
        return (
          <UiBuilderPagesCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></UiBuilderPagesCreate>
        );
      case UIBUILDER_PAGE_EDIT:
        return (
          <UiBuilderPagesCreate
            toggleDrawer={onDrawerToggle}
            page={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></UiBuilderPagesCreate>
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case UIBUILDER_PAGE_BUILDER:
        return (
          <UiBuilderPageBuilder
            groupId={groupId}
            page={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></UiBuilderPageBuilder>
        );

      default:
        break;
    }
  };

  const onViewToggle = (type, status, obj) => {
    dispatch(setIsUiBuilderEditModeStatus(status));
    setViewState({ type: type, status: status, obj: obj });
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>Design Configs</span>
            </div>
            <div className='col-md-6 d-flex justify-content-end'>
              {/* sync button might come in the future sprint */}
              {/* <IconButton
                className="shadow"
              >
                <CloudCircleIcon />
              </IconButton> */}
            </div>
          </div>
          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex flex-wrap'>
              <Button
                size='large'
                variant={activeTab === UIBUILDER_PAGES ? 'outlined' : 'text'}
                className={
                  activeTab === UIBUILDER_PAGES
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(UIBUILDER_PAGES)}
              >
                Pages
              </Button>
              <Button
                size='large'
                variant={activeTab === UIBUILDER_MENU ? 'outlined' : 'text'}
                className={
                  activeTab === UIBUILDER_MENU ? classes.activeButton : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(UIBUILDER_MENU)}
              >
                Menu
              </Button>
            </div>
          </div>
          <div className='row m-2 d-flex pb-2'>
            <div className='card shadow'>
              {activeTab === UIBUILDER_PAGES && (
                <UiBuilderPagesList
                  showLoader={showLoader}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  onsetPage={(e) => setPage(e)}
                  pageNo={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === UIBUILDER_MENU && (
                <UiBuilderMenuList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  showLoader={showLoader}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UiBuilderMobile;
